export default __webpack_public_path__ + "static/media/target-okr.a626c182.svg";